import GLightbox from 'glightbox'

export default function () {
    const element = document.querySelector('.js-glightbox-modal');

    if (element === null) {
        return false;
    }

    GLightbox({
        selector: '.js-glightbox-modal',
        videosWidth: 1130
    });
}
